import { render, staticRenderFns } from "./onePage.vue?vue&type=template&id=94998cb4&scoped=true&"
import script from "./onePage.vue?vue&type=script&lang=js&"
export * from "./onePage.vue?vue&type=script&lang=js&"
import style0 from "./onePage.vue?vue&type=style&index=0&id=94998cb4&scoped=true&lang=css&"
import style1 from "./onePage.vue?vue&type=style&index=1&id=94998cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94998cb4",
  null
  
)

export default component.exports